// Form configuration service - fetches dynamic profile fields from backend
import type { FieldDTO } from './types';
import { apiRequestData } from '../http/apiClient';

/**
 * Fetch all profile fields with section metadata
 * Returns flat list of fields - consumer groups by sectionId
 */
export async function fetchProfileFields(): Promise<FieldDTO[]> {
  // All fields in one page; the response is { data, meta } and only data is needed.
  return apiRequestData<FieldDTO[]>('/api/v1/profile-fields?disablePagination=true');
}
